<div class="mt-4">
  <h5><strong>Terms & Conditions</strong></h5>
  <p style="color: #6D6D6D;">Manage the Terms and Conditions for Users</p>

  <div class="container-fluid mt-4">
    <!-- Tourist Terms -->
    <div class="row mb-4">
      <div class="col-12 p-4 border rounded d-flex justify-content-between align-items-center bg-white shadow-sm">
        <div>
          <h6 class="mb-2"><strong>Tourist Terms & Conditions</strong></h6>
          <p class="mb-1" style="color: #6D6D6D;" *ngIf="touristTerms">
            Last Updated: {{touristTerms.updatedDate | date:'mediumDate'}}
          </p>
          <p class="mb-1" style="color: #6D6D6D;" *ngIf="!touristTerms">
            No Terms Uploaded Yet
          </p>
          <a *ngIf="touristTerms" [href]="touristTerms.fileUrl" target="_blank"
            style="color: #309EAE; font-size: 14px; text-decoration: none;">View Current PDF</a>
        </div>
        <div>
          <input type="file" #touristFileInput style="display: none" (change)="onFileSelected($event, 'Tourist')"
            accept="application/pdf">
          <button class="btn text-white rounded-pill px-4" style="background-color: #286676;"
            (click)="touristFileInput.click()" [disabled]="isUploadingTourist">
            {{ isUploadingTourist ? 'Uploading...' : 'Upload PDF' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Tourguide Terms -->
    <div class="row">
      <div class="col-12 p-4 border rounded d-flex justify-content-between align-items-center bg-white shadow-sm">
        <div>
          <h6 class="mb-2"><strong>Tourguide Terms & Conditions</strong></h6>
          <p class="mb-1" style="color: #6D6D6D;" *ngIf="tourguideTerms">
            Last Updated: {{tourguideTerms.updatedDate | date:'mediumDate'}}
          </p>
          <p class="mb-1" style="color: #6D6D6D;" *ngIf="!tourguideTerms">
            No Terms Uploaded Yet
          </p>
          <a *ngIf="tourguideTerms" [href]="tourguideTerms.fileUrl" target="_blank"
            style="color: #309EAE; font-size: 14px; text-decoration: none;">View Current PDF</a>
        </div>
        <div>
          <input type="file" #tourguideFileInput style="display: none" (change)="onFileSelected($event, 'Tourguide')"
            accept="application/pdf">
          <button class="btn text-white rounded-pill px-4" style="background-color: #286676;"
            (click)="tourguideFileInput.click()" [disabled]="isUploadingTourguide">
            {{ isUploadingTourguide ? 'Uploading...' : 'Upload PDF' }}
          </button>
        </div>
      </div>
    </div>


    <!-- Payment Terms -->
<div class="row mb-4">
  <div class="col-12 p-4 border rounded d-flex justify-content-between align-items-center bg-white shadow-sm">
    <div>
      <h6 class="mb-2"><strong>Payment Terms & Conditions</strong></h6>
      <p class="mb-1" style="color: #6D6D6D;" *ngIf="paymentTerms">Last Updated: {{paymentTerms.updatedDate | date:'mediumDate'}}</p>
      <p class="mb-1" style="color: #6D6D6D;" *ngIf="!paymentTerms">No Terms Uploaded Yet</p>
      <a *ngIf="paymentTerms" [href]="paymentTerms.fileUrl" target="_blank" style="color: #309EAE; font-size: 14px; text-decoration: none;">View Current PDF</a>
    </div>
    <div>
      <input type="file" #paymentFileInput style="display: none" (change)="onFileSelected($event, 'Payment')" accept="application/pdf" />
      <button class="btn text-white rounded-pill px-4" style="background-color: #286676;" (click)="paymentFileInput.click()" [disabled]="isUploadingPayment">
        {{ isUploadingPayment ? 'Uploading...' : 'Upload PDF' }}
      </button>
    </div>
  </div>
</div>

  </div>
</div>